import {helpers} from 'vuelidate/lib/validators'

// validator for registrar name
export const registrarName =
  helpers.regex ('registrarName', /^[A-Za-z][A-Za-z0-9.-]{0,28}[A-Za-z0-9]$/)
